<section class="quotation-vehicle">
    <div class="title with-divisor">
        <div class="left-section">
            <div class="title-with-observation">
                <h2>{{ 'buyer.create-quotation.quotation-vehicle.header.title' | translate }}</h2>

                @if (isQuotationWithParts) {
                    <span>{{ 'buyer.create-quotation.quotation-vehicle.header.observation' | translate }}</span>
                }
            </div>
            <p>{{ 'buyer.create-quotation.quotation-vehicle.header.subtitle' | translate }}</p>
        </div>

        @if (!isQuotationWithParts) {
            <div class="right-section">
                <label for="vehicleToggle">{{ 'buyer.create-quotation.quotation-vehicle.header.button' | translate }}</label>
                <label class="switch switch-lg">
                    <input id="vehicleToggle" type="checkbox" (click)="collapse.toggle()"/>
                    <span></span>
                </label>
            </div>
        }
    </div>

    <div #collapse="ngbCollapse" [(ngbCollapse)]="quotationVehicleCollapsed">
        <form [formGroup]="vehicleFormGroup" ngxUiLoaderBlurred [loaderId]="'loader-search-plate'" [blur]="0">
            <div class="left-section">
                <div class="first-line">
                    <select-component label="buyer.create-quotation.quotation-vehicle.form.label.insurance" [isDisabled]="loading.insurances" [control]="insuranceIdControl" [optionsGroups]="insuranceOptions" />
                    <input-component class="license-plate" label="buyer.create-quotation.quotation-vehicle.form.label.plate" (keyup)="searchApiPlate()" mask="SSS-0A00" [control]="licensePlateControl" [hasButton]="true" [buttonHasFunction]="plateLoaded" (onButtonClick)="editFieldsApiPlate()">
                        @if (plateLoaded) {
                            <i class="fa fa-edit"></i>
                        } @else {
                            <i class="fa fa-search"></i>
                        }
                    </input-component>
                </div>
                <div class="seccond-line">
                    <input-component label="buyer.create-quotation.quotation-vehicle.form.label.vehicle" [control]="vehicleNameControl" />
                    <select-component #brandsInput label="buyer.create-quotation.quotation-vehicle.form.label.brand" [isDisabled]="loading.brands" [control]="brandIdControl" [optionsGroups]="brandOptions" />
                </div>
            </div>
            <div class="right-section">
                <input-component label="buyer.create-quotation.quotation-vehicle.form.label.year" type="number" mask="0000" [minValue]="1950" [maxValue]="maxYear" class="small-input" [control]="yearControl" />
                <input-component label="buyer.create-quotation.quotation-vehicle.form.label.chassi" mask="AAAAAAAAAAAAAAAAA" [control]="chassiControl" />
            </div>

            <ngx-ui-loader [loaderId]="'loader-search-plate'" [hasProgressBar]="false" [fgsSize]="45"></ngx-ui-loader>
        </form>
    </div>
</section>
